import { effects as paymentEffects } from './payments';
import { effects as settingsEffects } from './settings';
import { effects as wizardEffects } from './wizards';
import { effects as authEffects } from './auth';
import { effects as partnerEffects } from './partner';
import { effects as customersEffects } from './customers';
import { effects as ordersEffects } from './orders';
import { effects as marketingEffects } from './marketing';
import { effects as welcomeEffects } from './welcome';

const effects = {
    ...paymentEffects,
    ...settingsEffects,
    ...wizardEffects,
    ...authEffects,
    ...partnerEffects,
    ...customersEffects,
    ...ordersEffects,
    ...marketingEffects,
    ...welcomeEffects,
};

export default effects;
